module.exports = __webpack_public_path__ + "img/downloadAndroidContent.7bfc4d4b.png";